import { actions } from "react-redux-form";
import {
    getVendorDetails,
    getInvoiceMaster,
    getBillingAccount,
    setInvoiceUploadError,
    InvoiceUploadModel,
    getInvoiceMasterConfig
} from "../../../../constants/model-reducers/external/invoice/invoice/invoice-upload.setting";
import { httpDownload, httpGet, httpPost } from "../../../../utils/api.utils";


export const invoideUpdateFormInitialState=InvoiceUploadModel;

const defaultState = ()=>({
    vendorOptions:[],
    invoiceMasteroptions: [],
    invoiceMasterConfig: {
        MinTotal: 0,
        MaxTotal: 0,
        AcceptedFileTypes: '',
        InvoiceMasterName: '',
        VendorDetailId: 0,
        IsMultipleVendorSupport: false,
        CustomControl: null,
    },
    billingAccount:[],
    invoiceUploadError:false
});

const initialState=defaultState();

function filterByVendor(vendorId, results, vendorOptions) {
    const vendor = vendorOptions.find(option => option.Key === vendorId);
    const vendorName = vendor ? vendor.Value : '';
    return vendorName ? results.filter(item =>
        item.InvoiceMasterName.includes(vendorName) || item.InvoiceMasterName === "Generic Handler" || item.InvoiceMasterName === "OCR Handler"
    ) : [];
}

export const invoiceUploadAction = {
    getVendorDetails:() => async(dispatch, state) => {
        var data = {
            country:'USA'
        };
        var res = await httpPost(`external/invoice/getUploadVendors`,data); 
        if(res.ok === false)
        {
            dispatch({
                type: setInvoiceUploadError,
                invoiceUploadError: false,
                vendorOptions: []
            })
        } else {
            dispatch({
                type: getVendorDetails,
                data: res
            }); 
        }     
    },
    getInvoiceMaster:(vendorId)=> async(dispatch,state) =>{
        const vendorState=state()
        const {vendorOptions}=vendorState.invoiceUpload;
        var res = await httpGet(`invoiceMaster/getMasterInvoiceByDealName/${sessionStorage.getItem('DealName')}/${vendorId}`);
        const filterVendor = filterByVendor(vendorId, res, vendorOptions);
        if(res.ok === false)
        {
            dispatch({
                type: setInvoiceUploadError,
                invoiceUploadError: false,
                invoiceMasteroptions: []
            })
        } else {
            dispatch({
                type: getInvoiceMaster,
                data: filterVendor
            }); 
        }     
    },   
    getBillingAccount:()=>async(dispatch,state) =>{     
        const {invoiceUploadForm} = state().form;
       var res = await httpGet(`external/invoice/getInvoiceBillingAccount/${invoiceUploadForm.vendorId}`);
        if(res.ok === false)
        {
            dispatch({
                type: setInvoiceUploadError,
                invoiceUploadError: false,
                billingAccount: []
            })
        } else {
            dispatch({
                type: getBillingAccount,
                data: res
            }); 
        }    
    },
    getInvoiceMasterConfig: (invoiceGuid) => async (dispatch) => {
        var res = await httpGet('invoiceMaster/GetMasterInvoiceById/' + invoiceGuid);

        dispatch({
            type: getInvoiceMasterConfig,
            data: res
        });
    },
    postExecuteHandlerProcess: (batchId) => () => {
        var url = 'external/upload/executeInvoiceHandlerProcess';

        httpPost(url, batchId);
    },
    resetUploadForm:()=>async(dispatch,state) =>{
        dispatch(actions.reset('invoiceUploadForm.financeAccountId'));
        dispatch(actions.reset('invoiceUploadForm.invoiceDate'));
        dispatch(actions.reset('invoiceUploadForm.invoiceNumber'));
        dispatch(actions.reset('invoiceUploadForm.fanChargesAndCredits'));
    },
    downloadGenericTemplate: (fileAttachmentModule, fileName) => async (dispatch, getState) => {
        const encodedFileName = encodeURIComponent(fileName);
        try {
            const response = await httpDownload(`common/fileAttachment/downloadFile/${fileAttachmentModule}/${encodedFileName}`);
            if (response.ok) {
                response.blob().then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                });
            } else {
                dispatch({
                    type: setInvoiceUploadError,
                    invoiceUploadError: false,
                })
            }
        } catch (error) {
            dispatch({
                type: setInvoiceUploadError,
                invoiceUploadError: false,
            })
        }
    }
}

export const reducer=(state,action)=>{
    state = state || initialState;
    switch(action.type) {
        case getVendorDetails:
            return {
                ...state,
                vendorOptions: action.data
            }
        case getInvoiceMaster:
            return {
                ...state,
                invoiceMasteroptions: action.data
            }
        case getBillingAccount:
            return {
                ...state,
                billingAccount: action.data
            }
        case setInvoiceUploadError:
            return {
                ...state,
                invoiceUploadError: action.invoiceUploadError,
                billingAccount: action.billingAccount
            } 
        case getInvoiceMasterConfig:
            return {
                ...state,
                invoiceMasterConfig: action.data
            };
        default:
            return state
        }
}